export default __webpack_public_path__ + "static/media/trianguloVermelho.d2552148.png";